<div *ngIf="!isOpen" class="button" (click)="openPopout()">
    <div class="icon" [style]="icon | async"></div>
    <p class="bodySmallContentSemi">{{this.viewModel.onGetCaption | async}}</p>
</div>
<div *ngIf="isOpen" [class]="panelClass" #panel>
    <ng-content *ngTemplateOutlet="popoutPanel"></ng-content>
</div>
<div *ngIf="isOpen" class="grayOut" (click)="sluitPopout()"></div>
